import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  pageContent: {
    backgroundColor: "white",
    width: "100%",
    // height: "100%",
    borderRadius: "10px 10px 0px 0px",
    boxSizing: "border-box",
    paddingTop: "10px"
  },

  createFormContainer: {
    backgroundColor: "white",
    borderRadius: "10px 10px 0px 0px",
    boxSizing: "border-box",
    padding: "0px 20px 30px 10px",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 10px 0px 0px",
      marginLeft: "0px"
    }
  },
  paddingcont: {
    position: "relative",
    background: "white",
    "@media (max-width: 590px)": {
      paddingBlock: "14px"
    }
  },
  rightcont: {
    position: "relative",
    backgroundColor: "white",
    height: "calc(100vh - 300px)",
    boxSizing: "border-box",
    padding: "24px 15px 0px 15px",
    overflow: "scroll"
  },
  imageitems: {
    "& p": {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "17px",
      marginBlock: "0px 15px"
    }
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center"
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    textAlign: "left !important",
    marginBottom: 20,
    marginTop: 10
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  manageitem: {
    position: "relative"
  },
  deleteitem: {
    color: "#DD514D",
    fontSize: 15,
    fontWeight: 400
  },
  actionitems: {
    position: "absolute",
    marginTop: "-35px",
    right: "10px",
    fontSize: 12,
    color: "#667185",
    fontWeight: 400,
    cursor: "pointer",
    lineHeight: "15px"
  },
  anitem: {
    position: "absolute",
    marginTop: "-45px",
    right: "10px",
    fontSize: 12,
    color: "#667185",
    fontWeight: 400,
    cursor: "pointer",
    lineHeight: "15px"
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  customTooltip: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontSize: "0.875rem",
    padding: "8px 12px",
    borderRadius: "6px",
    whiteSpace: "pre-line"
  },
  arrow: {
    color: "#333"
  },
  mail: {
    // paddingLeft: "3%",
    cursor: "pointer",
    fontSize: "14px",
    gap: "7px",
    color: theme.palette.primary.main,
    fontWeight: "400",
    lineHeight: "17.4px",
    "& p": {
      marginBlock: "10px"
    }
  },
  actionitem: {
    fontSize: "14px",
    color: theme.palette.primary.main,
    fontWeight: "400 !important",
    cursor: "pointer"
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  flexOnly: {
    display: "flex",
    gap: "16px",
    width: "100%",
    justifyContent: "center",
    marginBlock: "12px 32px"
  },
  previewGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    marginBlock: "1.3rem"
  },
  previewItem: {
    position: "relative",
    width: "100px",
    height: "100px"
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px"
  },
  removeBtn: {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    background: "#ff4d4d",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.75rem"
  },
  previewsubheader: {
    display: "flex",
    borderRadius: "6px",
    // border: `1px solid ${theme.palette.primary.main}`,
    // padding: "14px",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    marginBottom: "8px",
    "& h5": {
      fontWeight: "700",
      fontSize: "16px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h4": {
      fontWeight: "400",
      fontSize: "16px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px",
      color: "#667185"
    }
  },
  rightitems: {
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px",
      color: "#667185",
      textAlign: "left"
    },
    "& h5": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "14px",
      color: "#6C737F",
      textAlign: "left"
    }
  },
  logtitle: {
    "& h4": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "16px",
      marginBottom: "10px",
      color: "#000",
      textAlign: "left"
    }
  },
  notedetails: {
    height: "100%",
    overflow: "scroll",
    "& h4": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "14px",
      color: "black",
      textAlign: "left"
    },
    "& h5": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "11.33px",
      color: "#6C737F",
      textAlign: "left"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "9.71px",
      color: "#6C737F",
      marginBlock: "0px",
      textAlign: "left"
    },
    "@media (max-width: 900px)": {
      height: "100%"
    }
  },
  verticalline: {
    paddingLeft: 15,
    paddingBottom: 5,
    textAlign: "left"
  },
  fordesc: {
    "& p": {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "17px",
      marginBlock: "0px 10px",
      textAlign: "left !important"
    }
  },
  textandimg: {
    position: "relative",
    borderRadius: "6px",
    border: "1px solid hsl(0, 0%, 80%)",
    backgroundColor: "white",
    height: "110px",
    "& textarea": {
      width: "100%",
      height: "110px",
      boxSizing: "border-box",
      background: "none",
      border: "0px",
      paddingBlock: "10px",
      paddingLeft: "10px",
      paddingRight: "35px",
      color: "black"
    }
  }

}));
